import { render } from "./BaseAudioElement.vue?vue&type=template&id=7a604c4c&scoped=true&ts=true"
import script from "./BaseAudioElement.vue?vue&type=script&lang=ts"
export * from "./BaseAudioElement.vue?vue&type=script&lang=ts"

import "./BaseAudioElement.vue?vue&type=style&index=0&id=7a604c4c&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a604c4c"]])

export default __exports__